import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const TradingViewWidget = ({theme,notTransparent}) => {
    useEffect(() => {
        // Check if the script is already present
        if (!document.getElementById('tradingview-widget-script')) {
          const script = document.createElement("script");
          script.id = 'tradingview-widget-script';
          script.src = "https://s3.tradingview.com/external-embedding/embed-widget-screener.js";
          script.async = true;
      
          const config = {
            width: "100%",
            height: "450",
            defaultColumn: "overview",
            screener_type: "crypto_mkt",
            displayCurrency: "USD",
            colorTheme: theme || "dark",
            locale: "en",
            isTransparent: notTransparent || true,
          };
      
          script.innerHTML = JSON.stringify(config);
      
          const container = document.getElementById("tradingview-widget");
          if (container) {
            container.innerHTML = ""; // Clear any existing content to prevent duplication
            container.appendChild(script);
          }
        }
      }, []);
      

  return (
    <div>
        <div className="tradingview-widget-container jejekkeeeekekekek">
      <div className="tradingview-widget-container__widget" id="tradingview-widget"></div>
      <div className="tradingview-widget-copyright">
        <Link href="#" rel="noopener" target="_blank">
          <span className="blue-text">Cryptocurrency Markets</span>
        </Link>{" "}
        Live Updates
      </div>
    </div>
    </div>
  );
};

export default TradingViewWidget;
